export function beginSend(context, compositionId) {
  const inFlightSends = context.stores.inFlightSends.get();
  if (inFlightSends.has(compositionId)) {
    return false;
  }

  inFlightSends.add(compositionId);
  context.stores.inFlightSends.set(inFlightSends);
  return true;
}

export function endSend(context, compositionId) {
  const inFlightSends = context.stores.inFlightSends.get();
  if (!inFlightSends.has(compositionId)) {
    return;
  }

  inFlightSends.remove(compositionId);
  context.stores.inFlightSends.set(inFlightSends);
}

export function isSending(context, compositionId) {
  return context.stores.inFlightSends.get().has(compositionId);
}
